// #### DIRECT SELECTORS
export const selectTableData = (state, aid) => state.tableData.data[aid]
export const selectTableRowData = (state, aid, rowIndex) => (state.tableData.data[aid] ? state.tableData.data[aid][rowIndex] : null)
